import { OndemandVideo } from "@mui/icons-material";
import { Videos } from "Pages";

const VideosContent = {
  title: "Videos",
  playlistID: "PLSSiOHuH9TepRYQeN6VO8ClZ9URqeTuBm",
  icon: <OndemandVideo />,
  path: "/media/videos",
  menuIndex: 1,
  element: <Videos />,
};
export default VideosContent;
